function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*
Language: Nix
Author: Domen Kožar <domen@dev.si>
Description: Nix functional language
Website: http://nixos.org/nix
Category: system
*/

/** @type LanguageFn */
function nix(hljs) {
  var regex = hljs.regex;
  var KEYWORDS = {
    keyword: ["assert", "else", "if", "in", "inherit", "let", "or", "rec", "then", "with"],
    literal: ["true", "false", "null"],
    built_in: [// toplevel builtins
    "abort", "baseNameOf", "builtins", "derivation", "derivationStrict", "dirOf", "fetchGit", "fetchMercurial", "fetchTarball", "fetchTree", "fromTOML", "import", "isNull", "map", "placeholder", "removeAttrs", "scopedImport", "throw", "toString"]
  };
  var BUILTINS = {
    scope: 'built_in',
    match: regex.either.apply(regex, _toConsumableArray(["abort", "add", "addDrvOutputDependencies", "addErrorContext", "all", "any", "appendContext", "attrNames", "attrValues", "baseNameOf", "bitAnd", "bitOr", "bitXor", "break", "builtins", "catAttrs", "ceil", "compareVersions", "concatLists", "concatMap", "concatStringsSep", "convertHash", "currentSystem", "currentTime", "deepSeq", "derivation", "derivationStrict", "dirOf", "div", "elem", "elemAt", "false", "fetchGit", "fetchMercurial", "fetchTarball", "fetchTree", "fetchurl", "filter", "filterSource", "findFile", "flakeRefToString", "floor", "foldl'", "fromJSON", "fromTOML", "functionArgs", "genList", "genericClosure", "getAttr", "getContext", "getEnv", "getFlake", "groupBy", "hasAttr", "hasContext", "hashFile", "hashString", "head", "import", "intersectAttrs", "isAttrs", "isBool", "isFloat", "isFunction", "isInt", "isList", "isNull", "isPath", "isString", "langVersion", "length", "lessThan", "listToAttrs", "map", "mapAttrs", "match", "mul", "nixPath", "nixVersion", "null", "parseDrvName", "parseFlakeRef", "partition", "path", "pathExists", "placeholder", "readDir", "readFile", "readFileType", "removeAttrs", "replaceStrings", "scopedImport", "seq", "sort", "split", "splitVersion", "storeDir", "storePath", "stringLength", "sub", "substring", "tail", "throw", "toFile", "toJSON", "toPath", "toString", "toXML", "trace", "traceVerbose", "true", "tryEval", "typeOf", "unsafeDiscardOutputDependency", "unsafeDiscardStringContext", "unsafeGetAttrPos", "warn", "zipAttrsWith"].map(function (b) {
      return "builtins\\.".concat(b);
    }))),
    relevance: 10
  };
  var IDENTIFIER_REGEX = '[A-Za-z_][A-Za-z0-9_\'-]*';
  var LOOKUP_PATH = {
    scope: 'symbol',
    match: new RegExp("<".concat(IDENTIFIER_REGEX, "(/").concat(IDENTIFIER_REGEX, ")*>"))
  };
  var PATH_PIECE = "[A-Za-z0-9_\\+\\.-]+";
  var PATH = {
    scope: 'symbol',
    match: new RegExp("(\\.\\.|\\.|~)?/(".concat(PATH_PIECE, ")?(/").concat(PATH_PIECE, ")*(?=[\\s;])"))
  };
  var OPERATOR_WITHOUT_MINUS_REGEX = regex.either.apply(regex, ['==', '=', '\\+\\+', '\\+', '<=', '<\\|', '<', '>=', '>', '->', '//', '/', '!=', '!', '\\|\\|', '\\|>', '\\?', '\\*', '&&']);
  var OPERATOR = {
    scope: 'operator',
    match: regex.concat(OPERATOR_WITHOUT_MINUS_REGEX, /(?!-)/),
    relevance: 0
  }; // '-' is being handled by itself to ensure we are able to tell the difference
  // between a dash in an identifier and a minus operator

  var NUMBER = {
    scope: 'number',
    match: new RegExp("".concat(hljs.NUMBER_RE, "(?!-)")),
    relevance: 0
  };
  var MINUS_OPERATOR = {
    variants: [{
      scope: 'operator',
      beforeMatch: /\s/,
      // The (?!>) is used to ensure this doesn't collide with the '->' operator
      begin: /-(?!>)/
    }, {
      begin: [new RegExp("".concat(hljs.NUMBER_RE)), /-/, /(?!>)/],
      beginScope: {
        1: 'number',
        2: 'operator'
      }
    }, {
      begin: [OPERATOR_WITHOUT_MINUS_REGEX, /-/, /(?!>)/],
      beginScope: {
        1: 'operator',
        2: 'operator'
      }
    }],
    relevance: 0
  };
  var ATTRS = {
    beforeMatch: /(^|\{|;)\s*/,
    begin: new RegExp("".concat(IDENTIFIER_REGEX, "(\\.").concat(IDENTIFIER_REGEX, ")*\\s*=(?!=)")),
    returnBegin: true,
    relevance: 0,
    contains: [{
      scope: 'attr',
      match: new RegExp("".concat(IDENTIFIER_REGEX, "(\\.").concat(IDENTIFIER_REGEX, ")*(?=\\s*=)")),
      relevance: 0.2
    }]
  };
  var NORMAL_ESCAPED_DOLLAR = {
    scope: 'char.escape',
    match: /\\\$/
  };
  var INDENTED_ESCAPED_DOLLAR = {
    scope: 'char.escape',
    match: /''\$/
  };
  var ANTIQUOTE = {
    scope: 'subst',
    begin: /\$\{/,
    end: /\}/,
    keywords: KEYWORDS
  };
  var ESCAPED_DOUBLEQUOTE = {
    scope: 'char.escape',
    match: /'''/
  };
  var ESCAPED_LITERAL = {
    scope: 'char.escape',
    match: /\\(?!\$)./
  };
  var STRING = {
    scope: 'string',
    variants: [{
      begin: "''",
      end: "''",
      contains: [INDENTED_ESCAPED_DOLLAR, ANTIQUOTE, ESCAPED_DOUBLEQUOTE, ESCAPED_LITERAL]
    }, {
      begin: '"',
      end: '"',
      contains: [NORMAL_ESCAPED_DOLLAR, ANTIQUOTE, ESCAPED_LITERAL]
    }]
  };
  var FUNCTION_PARAMS = {
    scope: 'params',
    match: new RegExp("".concat(IDENTIFIER_REGEX, "\\s*:(?=\\s)"))
  };
  var EXPRESSIONS = [NUMBER, hljs.HASH_COMMENT_MODE, hljs.C_BLOCK_COMMENT_MODE, hljs.COMMENT(/\/\*\*(?!\/)/, /\*\//, {
    subLanguage: 'markdown',
    relevance: 0
  }), BUILTINS, STRING, LOOKUP_PATH, PATH, FUNCTION_PARAMS, ATTRS, MINUS_OPERATOR, OPERATOR];
  ANTIQUOTE.contains = EXPRESSIONS;
  var REPL = [{
    scope: 'meta.prompt',
    match: /^nix-repl>(?=\s)/,
    relevance: 10
  }, {
    scope: 'meta',
    beforeMatch: /\s+/,
    begin: /:([a-z]+|\?)/
  }];
  return {
    name: 'Nix',
    aliases: ["nixos"],
    keywords: KEYWORDS,
    contains: EXPRESSIONS.concat(REPL)
  };
}

module.exports = nix;